// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__xH7KL","header":"Page_header__7qSrU","goBack":"Page_goBack__RpTuO","title":"Page_title__ASWgF","pageContent":"Page_pageContent__mZ2-r"};